module.exports = __webpack_public_path__ + "static/media/cz.c1ef5992.svg";